/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../../Fixes';
import Builder from '../../../../../Builder';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "connect": {
        "nested": {
          "v2": {
            "nested": {
              "merchant_catalog": {
                "nested": {
                  "service": {
                    "nested": {
                      "TransactionInfo": {
                        "fields": {
                          "openTransaction": {
                            "type": "bool",
                            "id": 1,
                            "rule": "optional"
                          },
                          "lockToken": {
                            "type": "string",
                            "id": 2,
                            "rule": "optional"
                          },
                          "lockDurationMs": {
                            "type": "int64",
                            "id": 3,
                            "rule": "optional"
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.merchant_catalog?.nested?.service?.nested?.TransactionInfo) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE TransactionInfo @ squareup/connect/v2/catalog/interfaces/transaction_info.proto at 16:1
 */
export const TransactionInfo = $root.lookupType('squareup.connect.v2.merchant_catalog.service.TransactionInfo');
fixType(TransactionInfo);
Builder.createAndAttachToType(TransactionInfo);